export default __webpack_public_path__ + "static/media/crossroads7.d5fe35e5.webp";